export const KEY_PREFIX = '@GuigoTV-'

export default {
  get: (key, defaultValue) => {
    const data = localStorage.getItem(KEY_PREFIX.concat(key))
    if (!data || data === 'undefined') {
      return defaultValue
    }
    return JSON.parse(data)
  },

  set: (key, value) => localStorage.setItem(KEY_PREFIX.concat(key), JSON.stringify(value)),

  remove: key => localStorage.removeItem(KEY_PREFIX.concat(key)),

  clear: () => localStorage.clear(),
}
